/*
 * Sticky add to cart for the Refresh Product section.
 *
 * Options are mirrored from the section's own supply cards and purchase
 * options rather than rebuilt from product data, so labels and availability
 * cannot drift. Selecting an option drives the section's real input and lets
 * the existing purchase controller update prices, the selling plan and the
 * cart form. Adding to cart clicks the section's own submit button, which
 * keeps Ella's cart drawer and the subscription handling intact.
 */
(function () {
  'use strict';

  var DRAWER_CLASSES = [
    'cart-sidebar-show',
    'cart-modal-show',
    'add-to-cart-show',
    'edit-cart-show',
    'open-mobile-sidebar',
    'menu_open'
  ];

  function RefreshStickyATC(el) {
    this.el = el;
    this.sectionId = el.dataset.section;
    this.productSection = document.getElementById(el.dataset.productSection);
    if (!this.productSection) return;

    this.purchaseRoot = this.productSection.querySelector('[data-sm-purchase-section]');
    this.mainAddBtn = this.productSection.querySelector('[data-btn-addToCart]');

    this.panel = el.querySelector('.refresh-sticky-atc__panel');
    this.optionsWrap = el.querySelector('[data-sticky-options]');
    this.expandBtn = el.querySelector('[data-sticky-expand]');
    this.closeBtn = el.querySelector('[data-sticky-close]');
    this.barAddBtn = el.querySelector('[data-sticky-bar-add]');
    this.submitBtn = el.querySelector('[data-sticky-submit]');

    this.expanded = false;
    this.variantGate = el.dataset.variantGate === 'true';

    this.thresholds = {
      desktop: parseFloat(el.dataset.scrollDesktop) || 0,
      tablet: parseFloat(el.dataset.scrollTablet) || 0,
      mobile: parseFloat(el.dataset.scrollMobile) || 0
    };

    // Move to the end of body so it layers above third-party widgets.
    document.body.appendChild(el);
    window.setTimeout(function () { document.body.appendChild(el); }, 1500);

    this.buildOptions();
    this.syncFromSection();
    this.bindEvents();
    this.observeMainButton();
    this.observeDrawer();
    this.bindScroll();
  }

  /* ---------- options mirrored from the section ---------- */

  RefreshStickyATC.prototype.sourceGroups = function () {
    var groups = [];
    if (!this.purchaseRoot) return groups;

    var cards = this.purchaseRoot.querySelectorAll('[data-sm-variant-card]');
    if (cards.length > 1) {
      groups.push({
        key: 'variant',
        label: this.labelFor('[data-sm-supply-heading]', 'Choose your supply'),
        items: Array.prototype.map.call(cards, function (card) {
          var input = card.querySelector('[data-sm-variant-input]');
          var name = card.querySelector('[data-sm-variant-name]');
          return {
            input: input,
            text: name ? name.textContent.trim() : (input ? input.value : ''),
            available: input ? !input.disabled : false,
            selected: input ? input.checked : false
          };
        })
      });
    }

    var options = this.purchaseRoot.querySelectorAll('.sm-purchase-option');
    if (options.length > 1) {
      groups.push({
        key: 'purchase',
        label: 'How it arrives',
        items: Array.prototype.map.call(options, function (option) {
          var input = option.querySelector('[data-sm-purchase-input]');
          var copy = option.querySelector('.sm-purchase-copy');
          var text = copy ? copy.childNodes[0] : null;
          return {
            input: input,
            text: (text && text.textContent.trim()) || option.textContent.trim().split('\n')[0],
            available: input ? !input.disabled : false,
            selected: input ? input.checked : false
          };
        })
      });
    }

    return groups;
  };

  RefreshStickyATC.prototype.labelFor = function (selector, fallback) {
    var el = this.purchaseRoot.querySelector(selector) ||
             this.purchaseRoot.querySelector('.form-label');
    return el ? el.textContent.trim() : fallback;
  };

  RefreshStickyATC.prototype.buildOptions = function () {
    if (!this.optionsWrap) return;
    var self = this;
    var groups = this.sourceGroups();

    this.optionsWrap.innerHTML = '';
    groups.forEach(function (group) {
      var fieldset = document.createElement('fieldset');
      fieldset.className = 'refresh-sticky-atc__option-group';

      var legend = document.createElement('legend');
      legend.className = 'refresh-sticky-atc__option-label';
      legend.textContent = group.label;
      fieldset.appendChild(legend);

      var values = document.createElement('div');
      values.className = 'refresh-sticky-atc__option-values';

      group.items.forEach(function (item) {
        if (!item.input) return;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'refresh-sticky-atc__option-btn';
        btn.textContent = item.text;
        btn.dataset.group = group.key;
        if (!item.available) {
          btn.setAttribute('data-unavailable', '');
          btn.setAttribute('aria-disabled', 'true');
        }
        btn.addEventListener('click', function () {
          if (btn.hasAttribute('data-unavailable')) return;
          self.choose(item.input);
        });
        btn._smInput = item.input;
        values.appendChild(btn);
      });

      fieldset.appendChild(values);
      self.optionsWrap.appendChild(fieldset);
    });

    // Only offer the panel when there is something to choose.
    if (this.expandBtn) this.expandBtn.hidden = groups.length === 0;
  };

  RefreshStickyATC.prototype.choose = function (input) {
    if (!input || input.disabled) return;
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };

  /* ---------- state sync ---------- */

  RefreshStickyATC.prototype.syncFromSection = function () {
    var self = this;

    // Reflect the section's current selection on the mirrored buttons.
    this.el.querySelectorAll('.refresh-sticky-atc__option-btn').forEach(function (btn) {
      var input = btn._smInput;
      if (!input) return;
      btn.classList.toggle('is-selected', !!input.checked);
      btn.toggleAttribute('data-unavailable', !!input.disabled);
    });

    var card = this.purchaseRoot &&
      this.purchaseRoot.querySelector('[data-sm-variant-card].is-selected');
    var current = card && card.querySelector('[data-sm-active-price]');
    var compare = card && card.querySelector('[data-sm-compare-price]');

    var priceText = current ? current.textContent.trim() : '';
    var compareText = compare && !compare.hidden ? compare.textContent.trim() : '';

    this.el.querySelectorAll('[data-sticky-price-current]').forEach(function (node) {
      node.textContent = priceText;
    });
    this.el.querySelectorAll('[data-sticky-price-compare]').forEach(function (node) {
      node.textContent = compareText;
      node.hidden = !compareText;
    });

    var soldOut = !!(this.mainAddBtn && this.mainAddBtn.disabled);
    [this.barAddBtn, this.submitBtn].forEach(function (btn) {
      if (!btn) return;
      btn.disabled = soldOut;
      var span = btn.querySelector('span') || btn;
      if (!btn._busy) span.textContent = soldOut ? 'Sold Out' : self.defaultLabel(btn);
    });
  };

  RefreshStickyATC.prototype.defaultLabel = function (btn) {
    if (!btn._defaultLabel) {
      var span = btn.querySelector('span') || btn;
      btn._defaultLabel = span.textContent.trim() || 'Add to Cart';
    }
    return btn._defaultLabel;
  };

  /* ---------- events ---------- */

  RefreshStickyATC.prototype.bindEvents = function () {
    var self = this;

    if (this.expandBtn) {
      this.expandBtn.addEventListener('click', function () { self.togglePanel(); });
    }
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', function () { self.collapsePanel(); });
    }
    if (this.barAddBtn) {
      this.barAddBtn.addEventListener('click', function () {
        if (self.variantGate && self.expandBtn && !self.expandBtn.hidden && !self.expanded) {
          self.expandPanel();
          return;
        }
        self.addToCart();
      });
    }
    if (this.submitBtn) {
      this.submitBtn.addEventListener('click', function () { self.addToCart(); });
    }

    document.addEventListener('click', function (e) {
      // Only a real click-away should close the panel. The section dispatches a
      // synthetic click on the gallery thumbnail when the variant changes, and
      // that must not be mistaken for the user clicking outside.
      if (!e.isTrusted) return;
      if (self.expanded && !self.el.contains(e.target)) self.collapsePanel();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.expanded) self.collapsePanel();
    });

    // The section's controller announces every variant / plan change.
    this.productSection.addEventListener('smokai:purchase-change', function () {
      self.syncFromSection();
    });
  };

  /*
   * Visibility is derived from the button's own position rather than relying
   * solely on IntersectionObserver, which does not fire in every rendering
   * context. The observer is kept purely as an extra recompute trigger.
   */
  RefreshStickyATC.prototype.mainButtonOutOfView = function () {
    if (!this.mainAddBtn) return window.scrollY > window.innerHeight;
    var r = this.mainAddBtn.getBoundingClientRect();
    // A button with no box (hidden) has nothing to scroll past, so fall back
    // to having scrolled a full screen.
    if (r.width === 0 && r.height === 0) return window.scrollY > window.innerHeight;
    // Only once the button has scrolled ABOVE the viewport. Treating
    // "below the fold, not yet reached" as out of view made the bar flash
    // on first paint, disappear as the button came into view, then return.
    return r.bottom <= 0;
  };

  RefreshStickyATC.prototype.observeMainButton = function () {
    var self = this;
    if (this.mainAddBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function () {
        self.updateVisibility();
      }, { threshold: 0 }).observe(this.mainAddBtn);
    }
    window.addEventListener('resize', function () { self.updateVisibility(); }, { passive: true });
    this.updateVisibility();
  };

  RefreshStickyATC.prototype.observeDrawer = function () {
    var self = this;
    var wasOpen = this.drawerOpen();
    new MutationObserver(function () {
      var isOpen = self.drawerOpen();
      if (isOpen === wasOpen) return;
      wasOpen = isOpen;
      // Only the drawer opening should close the panel; unrelated body class
      // churn (Klaviyo, sticky toolbars) must not.
      if (isOpen) self.collapsePanel();
      self.updateVisibility();
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  };

  RefreshStickyATC.prototype.drawerOpen = function () {
    return DRAWER_CLASSES.some(function (cls) {
      return document.body.classList.contains(cls);
    });
  };

  RefreshStickyATC.prototype.thresholdPx = function () {
    var w = window.innerWidth;
    var vh = w <= 749 ? this.thresholds.mobile
           : w <= 1199 ? this.thresholds.tablet
           : this.thresholds.desktop;
    return (vh / 100) * window.innerHeight;
  };

  RefreshStickyATC.prototype.bindScroll = function () {
    var self = this;
    window.addEventListener('scroll', function () {
      self.updateVisibility();
    }, { passive: true });
  };

  RefreshStickyATC.prototype.updateVisibility = function () {
    var outOfView = this.mainButtonOutOfView();
    var show = outOfView &&
               !this.drawerOpen() &&
               window.scrollY >= this.thresholdPx();

    // Collapse only when the main button scrolls back into view, so the panel
    // is not closed by unrelated recomputes.
    if (!outOfView && this.expanded) this.collapsePanel();

    this.el.classList.toggle('is-visible', show);
    this.el.setAttribute('aria-hidden', show ? 'false' : 'true');
  };

  /* ---------- panel ---------- */

  RefreshStickyATC.prototype.togglePanel = function () {
    this.expanded ? this.collapsePanel() : this.expandPanel();
  };

  RefreshStickyATC.prototype.expandPanel = function () {
    if (!this.panel) return;
    this.expanded = true;
    this.el.classList.add('is-expanded');
    this.panel.removeAttribute('hidden');
    if (this.expandBtn) this.expandBtn.setAttribute('aria-expanded', 'true');
  };

  RefreshStickyATC.prototype.collapsePanel = function () {
    if (!this.panel) return;
    this.expanded = false;
    this.el.classList.remove('is-expanded');
    this.panel.setAttribute('hidden', '');
    if (this.expandBtn) this.expandBtn.setAttribute('aria-expanded', 'false');
  };

  /* ---------- add to cart ---------- */

  RefreshStickyATC.prototype.addToCart = function () {
    var self = this;
    if (!this.mainAddBtn || this.mainAddBtn.disabled) return;

    var btns = [this.barAddBtn, this.submitBtn].filter(Boolean);
    var setLabel = function (text) {
      btns.forEach(function (btn) {
        var span = btn.querySelector('span') || btn;
        span.textContent = text;
      });
    };

    btns.forEach(function (btn) { btn._busy = true; btn.disabled = true; });
    setLabel('Adding\u2026');

    // Delegate to the section's own form so the purchase controller's submit
    // and formdata hooks supply the right variant and selling plan.
    this.mainAddBtn.click();

    // Ella signals a completed add by opening its cart drawer / notification.
    var settled = false;
    var finish = function (ok) {
      if (settled) return;
      settled = true;
      observer.disconnect();
      window.clearTimeout(timer);
      btns.forEach(function (btn) { btn._busy = false; });
      if (ok) {
        setLabel('Added!');
        self.collapsePanel();
        window.setTimeout(function () {
          btns.forEach(function (btn) {
            var span = btn.querySelector('span') || btn;
            span.textContent = self.defaultLabel(btn);
          });
          self.syncFromSection();
        }, 1800);
      } else {
        self.syncFromSection();
      }
    };

    var observer = new MutationObserver(function () {
      if (self.drawerOpen()) finish(true);
    });
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    // No drawer within this window: restore the buttons rather than claim success.
    var timer = window.setTimeout(function () { finish(self.drawerOpen()); }, 4000);
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-refresh-sticky-atc]').forEach(function (el) {
      if (el.dataset.stickyReady === 'true') return;
      el.dataset.stickyReady = 'true';
      new RefreshStickyATC(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
